import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';
import { MultiSiteTag } from './css';

const Row = ({
  keys,
  row,
  rowIndex,
  getFeilds,
  actions,
  dataModel = {},
  header
}) => {
  const { groupId, groupRecords } = row;
  const [open, setOpen] = useState(false);
  const [sites, setSitesList] = useState([]);

  useEffect(() => {
    if (groupId) {
      const temp = [row].concat(groupRecords);
      temp.sort((a, b) => (a.currentSite > b.currentSite && 1) || -1);

      setSitesList(temp);
    }
  }, [groupId]);

  const renderParentRow = () => {
    const { businessLegalName } = row;
    return (
      <tr onClick={() => setOpen(!open)}>
        <td>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            {`${groupId || '------'}`}
            <MultiSiteTag>Multi site</MultiSiteTag>
          </div>
        </td>
        <td />
        <td />
        <td>{`${businessLegalName || '------'}`}</td>
        <td />
        <td />
        <td />
        <td />
        <td />
        <td />
        <td />
        <td style={{ textAlign: 'center', cursor: 'pointer' }}>
          {open ? <MdExpandLess size={20} /> : <MdExpandMore size={20} />}{' '}
        </td>
        {Array.from({ length: Math.max(keys.length - 12, 0) }, (_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <td key={`parent-filler-${i}`} />
        ))}
      </tr>
    );
  };

  const renderChildRow = (data, rIndex, isChildRow) => {
    const rowData =
      // eslint-disable-next-line new-cap
      (dataModel && dataModel.length && new dataModel(data)) || data;

    return (
      <tr style={{ backgroundColor: groupId ? '#fff9ef' : '' }}>
        {keys.map((cell, cellIndex) => {
          const cellKey = `cell${rIndex}.${cellIndex}`;
          return cell !== 'actions' ? (
            <td data-header-label={header[cellIndex]} key={cellKey}>
              {getFeilds(cell, cellKey, data, rowData, isChildRow)}
            </td>
          ) : (
            <td data-header-label={header[cellIndex]} key={cellKey}>
              {actions(data)}
            </td>
          );
        })}
      </tr>
    );
  };

  return (
    <>
      {groupId ? (
        <>
          {' '}
          {renderParentRow()}
          {open && (
            <>
              {sites && sites.length ? (
                sites.map((data, index) => renderChildRow(data, index, true))
              ) : (
                <></>
              )}
            </>
          )}
        </>
      ) : (
        <>{renderChildRow(row, rowIndex, false)}</>
      )}
    </>
  );
};

Row.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  row: PropTypes.objectOf(PropTypes.object).isRequired,
  rowIndex: PropTypes.number.isRequired,
  getFeilds: PropTypes.func.isRequired,
  actions: PropTypes.func.isRequired,
  dataModel: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  header: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Row;
